import React from "react";
import { colors, css, icons, glyphs } from "./";
import { useTranslation } from "react-i18next";

export enum Units {
  kG_grey = "kg_grey",
  kG_white = "kg_white",
  kG_blue = "kg_blue",
  pct_white = "pct_white",
  animalTotal_grey = "animalTotal_grey",
  animalsCapacity = "animalsCapacity"
}

export const useUnitsComponent = () => {
  const { t } = useTranslation();

  const units = {
    [Units.kG_grey]: (
      <div key={"kg_grey"} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "2px" }}>
        <glyphs.Kg fillColor={colors.greyPrimary} size="15px" key={"test"}/>
        <p key={"grey"} style={{ ...css.unitsFontstyle }}>{t("units.kg", {defaultValue: "KG"})}</p>
      </div>
    ),
    [Units.kG_white]: (
      <div key={"kg_white"} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "2px" }}>
        <glyphs.Kg size="15px" key={"test"}/>
        <p key={"white"} style={{ ...css.unitsFontstyle, color: colors.greyLightTertiary }}>{t("units.kg", {defaultValue: "KG"})}</p>
      </div>
    ),
    [Units.kG_blue]: (
      <div key={"kg_blue"} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "2px" }}>
         <glyphs.Kg fillColor={colors.graphBlueSeven} size="15px" key={"test"}/>
        <p key={"blue"} style={{ ...css.unitsFontstyle, color: colors.graphBlueSeven }}>{t("units.kg", {defaultValue: "KG"})}</p>
      </div>
    ),
    [Units.animalTotal_grey]: (
      <p style={{ ...css.unitsFontstyle }}>{t("menuHeaders.animals", {defaultValue: "Animals"})} / {t("units.total", {defaultValue: "Total"})}</p>
    ),
    [Units.pct_white]: (
      // <p key={"pct_white"} style={{ ...css.unitsFontstyle, color: colors.greyLightTertiary }}>% {t("units.pct")}</p>
      <div key={"pct_white"} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "2px" }}>
        <glyphs.Percent size="15px" key={"test"}/>
        <p key={"white"} style={{ ...css.unitsFontstyle, color: colors.greyLightTertiary }}>{t("units.pct", {defaultValue: "PCT"})}</p>
      </div>
    ),
    [Units.animalsCapacity]: (
      <p style={{ ...css.unitsFontstyle }}>{t("globalMenu.animals", {defaultValue: "Animals"})} / {t("units.capacity", {defaultValue: "Capacity"})}</p>
    )
  };

  return (unit: Units) => units[unit];
};